<template>
    <div v-if="images" :class="['image-scroller w-full mb-4', wrapperClass]">
        <div :class="['flex inner-box', {'fullwidth': fullwidth}]">
          <div v-for="(item, index) in images" :key="`menuImages-${index}`" class="item">
            <img :src="`${item.imageUrl}`" :alt="`${item.imageExplanation}`" />
          </div>
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'ImageScroller',
    props: {
        images: {
            type: [Array, String],
            default: 'フォトギャラリーを見る'
        },
        fullwidth:{
            type: Boolean,
            default: false
        },
        wrapperClass: {
            type: String,
            default: ""
        }
    }
}
</script>
<style lang="scss" scoped>
@import "./styles.scss";
</style>  